export default "__VITE_ASSET__DXbKv_oa__"